module.exports = __webpack_public_path__ + "img/重度霾.5d5c485a.png";